import { axiosInstanceV1, useAuthQuery } from "@bn/api";
import { LOAD_FUNDAMENTAL_BY_ISIN } from "@api/cacheKeys";
import type { Security } from "@bn/api/apiv1";

// Deliberately not the generated `useFundamentalsId`: the swagger declares this
// endpoint as `/v1/fundamentals/fundamentals/{id}` (doubled segment) and that
// call returns nothing. This single-segment path is the one that works — it is
// what this feature used before 41a13a9 removed it, and what rentablo-ui uses.
const loadFundamental = async (token: string | undefined, isin: string) => {
  const { data } = await axiosInstanceV1.get<Security>(
    `/fundamentals/${isin}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const useFundamental = (isin?: string) =>
  useAuthQuery(
    [LOAD_FUNDAMENTAL_BY_ISIN, isin],
    ({ token }) => loadFundamental(token, isin!),
    {
      enabled: !!isin,
    }
  );
